export const ROUTES = {
  DASHBOARD: '/performance-coach',
  PERFORMANCE_INDICATORS: '/performance-indicators',
};
